// Appearance engine — theme / accent / density / animations, persisted in localStorage.
const KEY = 'crm_appearance';

const ACCENTS = {
  violet: '246 72% 61%',
  teal: '173 58% 39%',
  blue: '217 91% 60%',
  emerald: '160 84% 39%',
  rose: '347 77% 50%',
  amber: '38 92% 50%',
};

export const ACCENT_OPTIONS = Object.keys(ACCENTS);

export const DEFAULT_APPEARANCE = {
  theme: 'light',
  accentColor: 'violet',
  compactMode: false,
  animationsEnabled: true,
};

export function loadAppearance() {
  try {
    return { ...DEFAULT_APPEARANCE, ...(JSON.parse(localStorage.getItem(KEY)) || {}) };
  } catch {
    return { ...DEFAULT_APPEARANCE };
  }
}

export function applyAppearance(a) {
  const root = document.documentElement;
  const dark = a.theme === 'dark' || (a.theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches);
  root.classList.toggle('dark', dark);
  const accent = ACCENTS[a.accentColor] || ACCENTS.violet;
  root.style.setProperty('--primary', accent);
  root.style.setProperty('--ring', accent);
  root.classList.toggle('compact', !!a.compactMode);
  root.classList.toggle('no-animations', a.animationsEnabled === false);
}

export function saveAppearance(a) {
  try { localStorage.setItem(KEY, JSON.stringify(a)); } catch {}
  applyAppearance(a);
}

// React to OS theme changes while in "system" mode
let _mql = null;
export function initAppearance() {
  applyAppearance(loadAppearance());
  if (!_mql && window.matchMedia) {
    _mql = window.matchMedia('(prefers-color-scheme: dark)');
    _mql.addEventListener?.('change', () => {
      const a = loadAppearance();
      if (a.theme === 'system') applyAppearance(a);
    });
  }
}
